import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router';
import { DesignUploadMode } from 'swag-common/interfaces';
import { Price } from 'swag-client-common/utils/price';
import CustomerMockup from 'swag-client-common/components/info/customer-mockup';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import css from '../../suggested-product-list.scss';
const SuggestedProduct = ({
  suggestedProduct: {
    limitedEdition,
    name,
    logos,
    variants,
    seoSlug,
    minPriceToUse,
    maxPriceToUse,
    minQuant,
    logoThumbnail,
    designUploadMode,
    descriptionForWarehouse
  },
  suggestedProduct,
  nearestVariant,
  imageClassName,
  productImageWrapper,
  onSuggestedProductClick
}) => {
  var _variant$images$front, _variant$images, _variant$images$front2;
  const notEmptyLocation = Object.values(logos).find(singleLocationsLogos => !!singleLocationsLogos.length);
  const isFullDesign = designUploadMode === DesignUploadMode.fullDesign;
  const firstLogo = notEmptyLocation && !isFullDesign ? notEmptyLocation[0] : {
    preview: null
  };
  const variant = variants[nearestVariant];
  const {
    rectangle,
    url
  } = (_variant$images$front = variant === null || variant === void 0 ? void 0 : (_variant$images = variant.images) === null || _variant$images === void 0 ? void 0 : (_variant$images$front2 = _variant$images.front) === null || _variant$images$front2 === void 0 ? void 0 : _variant$images$front2[0]) !== null && _variant$images$front !== void 0 ? _variant$images$front : {
    url: logoThumbnail
  };
  const image = {
    url,
    rectangle,
    alt: `${name} - ${descriptionForWarehouse}`
  };
  const isLE = !!(limitedEdition !== null && limitedEdition !== void 0 && limitedEdition.isLimitedEdition);
  const onClick = () => {
    onSuggestedProductClick(suggestedProduct);
  };
  return /*#__PURE__*/React.createElement(Link, {
    to: `${APP_ROUTES.PRODUCT}/${seoSlug}`,
    onClick: onClick,
    className: css.suggestedProductLink
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(css.container, {
      [css.limitedEditionContainer]: isLE
    })
  }, /*#__PURE__*/React.createElement(CustomerMockup, {
    image: image,
    LEClassName: css.LEClassName,
    isLE: isLE,
    autoadjustLogo: true,
    logoSrc: firstLogo.preview,
    innerWrapper: css.img,
    logoClassName: css.logoClassName,
    defaultWidth: 0.8,
    productImageWrapper: productImageWrapper,
    imageClassName: imageClassName
  }), /*#__PURE__*/React.createElement("div", {
    className: css.caption
  }, /*#__PURE__*/React.createElement("div", {
    className: css.name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: css.fromTo
  }, "From:\xA0", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, Price.formatPrice(minPriceToUse)), "\xA0to\xA0", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, Price.formatPrice(maxPriceToUse))), /*#__PURE__*/React.createElement("span", {
    className: css.minQty
  }, "Min Qty: ", /*#__PURE__*/React.createElement("span", {
    className: css.dark
  }, minQuant)))));
};
export { SuggestedProduct };